import { Card as AntCard } from 'antd'
import type { ComponentProps } from 'react'

type AntCardProps = ComponentProps<typeof AntCard>

export interface AppCardProps extends AntCardProps {}

export const AppCard = (props: AppCardProps) => <AntCard {...props} />

export const AppCardMeta = AntCard.Meta
export const AppCardGrid = AntCard.Grid
